import { useEffect, useRef } from 'react';
import {
    ITableState,
    ITableStructure,
    TableContainer,
    formatTableFormFromState,
    useAppDispatch,
    useAppSelector,
    useTheme,
} from '../../../base';
import {
    TableIds,
    IFetchSourceOfHireParams,
    getBasicColorsObject,
} from '../../../common';
import { tablesActions, tablesSelectors } from '../../../actions';
import { useTableCells } from './hooks/useTableCells';
import { useTableFilters } from './hooks/useTableFilters';

interface IHiringSourcesTableProps {
    reportFilter: IFetchSourceOfHireParams;
}

const HiringSourcesTable = ({ reportFilter }: IHiringSourcesTableProps) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const cells = useTableCells();
    const filters = useTableFilters();
    const isFirstRender = useRef(true);

    const tableState = useAppSelector((state) =>
        tablesSelectors.getTablesState(state, TableIds.HIRING_SOURCES)
    );

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        dispatch(
            tablesActions.fetchTableDataById({
                tableId: TableIds.HIRING_SOURCES,
                formData: formatTableFormFromState(
                    tableState as ITableState,
                    filters
                ),
                page: 1,
                baseColors: getBasicColorsObject(theme.palette),
            })
        );
    }, [reportFilter]);

    const tableStructure: ITableStructure = {
        id: TableIds.HIRING_SOURCES,
        cells,
        filters,
    };

    return <TableContainer structure={tableStructure} />;
};

export default HiringSourcesTable;
